import React, { useEffect, useState } from "react";

import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
} from "@material-ui/core";

import TextFieldCustom from "../../components/basic/TextFieldCustom";
import Btn from "../../components/buttons/Btn";
import { notify } from "../../utils/notify";
import { postService, putService } from "../../repositories/v1/service";
import validatesNotNull from "../../utils/validatesNotNull";

function ServicesCreateEdit({ row, handleClose, handleSave }) {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isConsumer, setIsConsumer] = useState(true);

  useEffect(() => {
    if (row?.Descricao) {
      setDescription(row?.Descricao);
    }

    if (typeof row?.FlagAtivo === "boolean") {
      setIsActive(row?.FlagAtivo);
    }

    if (typeof row?.FlagUtilizador === "boolean") {
      setIsConsumer(row?.FlagUtilizador);
    }
  }, [row]);

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const validation = validatesNotNull([
        { key: "description", value: description },
      ]);

      setErrors(validation.errorsValidation);
      if (validation.error) return;

      let resp = {};
      if (row?.Id) {
        resp = await putService({
          body: {
            Descricao: description,
            FlagAtivo: isActive,
            FlagUtilizador: isConsumer,
          },
          id: row.Id,
        });
      } else {
        resp = await postService({
          body: {
            Descricao: description,
            FlagAtivo: isActive,
            FlagUtilizador: isConsumer,
          },
        });
      }

      resp = resp.data;

      if (!resp?.success) {
        return notify("Não foi possível salvar os dados.");
      }

      notify("Serviço salvo com sucesso.", true, "info");

      handleSave({
        Id: row?.Id || resp?.data?.Id,
        Descricao: description,
        FlagAtivo: isActive,
        FlagUtilizador: isConsumer,
      });

      handleClose();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={loading ? () => {} : handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Vinculo Contrato ERP</DialogTitle>
      <DialogContent>
        <Grid container alignItems="center" justify="center" spacing={2}>
          <Grid item sm={10} xs={12}>
            <TextFieldCustom
              maxLength={255}
              label="Descrição"
              type="text"
              value={description}
              setValue={setDescription}
              error={errors.description}
              helperText={errors.description}
            />
          </Grid>

          <Grid item flex={1}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={isActive}
                  onChange={() => {
                    setIsActive((current) => !current);
                  }}
                  name="Ativo"
                />
              }
              label="Ativo"
            />
          </Grid>

          <Grid item flex={1}>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={isConsumer}
                  onChange={() => {
                    setIsConsumer((current) => !current);
                  }}
                  name="Utilizador"
                />
              }
              label="Utilizador"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        {!loading && (
          <Btn
            onClick={handleClose}
            label="Cancelar"
            bg-color="subGray"
            textcolor="gray"
          />
        )}

        <Btn
          onClick={handleSubmit}
          label={
            loading ? (
              <CircularProgress
                style={{ width: 22, height: 22, color: "white" }}
              />
            ) : (
              "Salvar"
            )
          }
        />
      </DialogActions>
    </Dialog>
  );
}

export { ServicesCreateEdit };
